import { selectSpecContractOpeningTimeEnd } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '../types/contract';

import { useTimerToEnd } from './timer-to-end';

const useTimerToSpecContractOpeningEnd = (
  kind: SpecContractType | PaidSpecContractType,
  callback?: () => void,
): number | null => {
  const endTime = useAppSelector((state) =>
    selectSpecContractOpeningTimeEnd(state, kind),
  );

  return useTimerToEnd(endTime, callback);
};

export { useTimerToSpecContractOpeningEnd };
